// C:\Users\aleja\Code\inventory_analytics\src\front\src\pages\RepairableSparePartsDeleted.jsx
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../store/appContext";
import "../styles/repairableSpareParts.css";

const RepairableSparePartsDeleted = () => {
  const { actions } = useContext(Context);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({});
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [sortBy, setSortBy] = useState("deleted_at");
  const [sortDir, setSortDir] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(query.trim());
      setPage(1);
    }, 350);
    return () => clearTimeout(timer);
  }, [query]);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError("");
    actions.listDeletedRepairableSpareParts(
      { q: debouncedQuery || undefined, page, per_page: perPage, sort_by: sortBy, sort_dir: sortDir },
      { signal: controller.signal },
    ).then((result) => {
      if (result.aborted) return;
      if (!result.success) {
        setError(result.error);
        return;
      }
      setItems(result.data?.items || []);
      setPagination(result.data?.pagination || {});
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [actions, debouncedQuery, page, perPage, sortBy, sortDir]);

  const sort = (field) => {
    if (sortBy === field) setSortDir((value) => value === "asc" ? "desc" : "asc");
    else {
      setSortBy(field);
      setSortDir("asc");
    }
    setPage(1);
  };

  return (
    <main className="container-fluid repairable-spare-parts deleted-cases-page">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1>Historial de eliminados</h1>
        <button className="btn btn-outline-secondary" onClick={() => navigate("/reparable-spare-parts")}>Volver</button>
      </div>
      <div className="d-flex gap-2 mb-3">
        <input className="form-control" value={query} onChange={(event) => setQuery(event.target.value)} maxLength={255}
          placeholder="Buscar por expediente, material, serie, proveedor, motivo o usuario" />
        <select className="form-select deleted-page-size" value={perPage} onChange={(event) => { setPerPage(Number(event.target.value)); setPage(1); }}>
          {[25, 50, 100].map((size) => <option key={size}>{size}</option>)}
        </select>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? <div className="text-center py-5">Cargando…</div> : (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead><tr>
              {[["case_number", "Expediente"], ["material_id", "ID material"], [null, "Descripción"], ["serial_number", "N.º de serie"], ["supplier_name", "Proveedor"], [null, "Estado"], ["deleted_at", "Eliminado el"], [null, "Eliminado por"], [null, "Motivo"], [null, "Acciones"]].map(([field, label]) =>
                <th key={label} onClick={() => field && sort(field)} className={field ? "deleted-sortable" : ""}>{label}</th>)}
            </tr></thead>
            <tbody>{items.length === 0 ? <tr><td colSpan={10}>No hay expedientes eliminados para los filtros seleccionados.</td></tr> :
              items.map((item) => <tr key={item.id}>
                <td>{item.case_number}</td><td>{item.material?.material_id || "—"}</td><td>{item.material?.description || "—"}</td>
                <td>{item.serial_number || "—"}</td><td>{item.supplier?.name || "—"}</td><td>{item.status}</td>
                <td>{item.deletion?.deleted_at ? new Date(item.deletion.deleted_at).toLocaleString("es-ES") : "—"}</td>
                <td>{item.deletion?.deleted_by?.username || "—"}</td><td className="deleted-reason-cell">{item.deletion?.reason || "—"}</td>
                <td><button className="btn btn-sm btn-outline-primary" onClick={() => navigate(`/reparable-spare-parts/${item.id}`)}>Ver ficha</button></td>
              </tr>)}</tbody>
          </table>
        </div>
      )}
      <div className="d-flex justify-content-between align-items-center">
        <span>Página {pagination.page || page} de {pagination.pages || 1}</span>
        <div className="btn-group"><button className="btn btn-outline-secondary" disabled={!pagination.has_prev} onClick={() => setPage((value) => value - 1)}>Anterior</button>
          <button className="btn btn-outline-secondary" disabled={!pagination.has_next} onClick={() => setPage((value) => value + 1)}>Siguiente</button></div>
      </div>
    </main>
  );
};

export default RepairableSparePartsDeleted;
